// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * If any `vias` are set, thes tranportMode-values will be considered until the first via. Optionally restrict to a requestable set of SBB specific TransportMode's (aka OJP PTMode). The set is relevant for any vehicle-journey (`DatedVehicleJourney`, `PTRideLeg`, ..). Relates to `ServiceProduct::vehicleMode` and `::vehicleSubModes`.
 * - Default: non-restricted (null or empty-list), by means all TransportMode's are searched.
 * - If some choice is made, other TransportMode's are excluded implicitely.
 * - To get TRAIN (VehicleMode::id) only, add: [HIGH_SPEED_TRAIN,INTERCITY,INTERREGIO,REGIO,URBAN_TRAIN,SPECIAL_TRAIN]
 * >- Be aware that TRAMWAY also searches for METRO (not distinguished it here further!)
 * - Also there is no exact possibility to distinguish more precisely between CABLEWAY_GONDOLA_CHAIRLIFT_FUNICULAR at search time<br><br>x-extensible-enum: 
 * @export
 */
export const TransportModeEnum = {
    HighSpeedTrain: 'HIGH_SPEED_TRAIN',
    Intercity: 'INTERCITY',
    Interregio: 'INTERREGIO',
    Regio: 'REGIO',
    UrbanTrain: 'URBAN_TRAIN',
    SpecialTrain: 'SPECIAL_TRAIN',
    Ship: 'SHIP',
    Bus: 'BUS',
    Tramway: 'TRAMWAY',
    CablewayGondolaChairliftFunicular: 'CABLEWAY_GONDOLA_CHAIRLIFT_FUNICULAR'
} as const;
export type TransportModeEnum = typeof TransportModeEnum[keyof typeof TransportModeEnum];


export function instanceOfTransportModeEnum(value: any): boolean {
    for (const key in TransportModeEnum) {
        if (Object.prototype.hasOwnProperty.call(TransportModeEnum, key)) {
            if (TransportModeEnum[key as keyof typeof TransportModeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TransportModeEnumFromJSON(json: any): TransportModeEnum {
    return TransportModeEnumFromJSONTyped(json, false);
}

export function TransportModeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportModeEnum {
    return json as TransportModeEnum;
}

export function TransportModeEnumToJSON(value?: TransportModeEnum | null): any {
    return value as any;
}

export function TransportModeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TransportModeEnum {
    return value as TransportModeEnum;
}

